import { ArticleParagraph1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './styles.css';

interface IOffersCountLinkProps {
  expanded: boolean;
  count: number;
  onClick: () => void;
}

export const OffersCountLink: FC<IOffersCountLinkProps> = ({ count, expanded, onClick }) => {
  return (
    <div className={styles['container']} data-testid="OffersCountLink" role="button" onClick={onClick}>
      {expanded ? (
        <>
          <ArticleParagraph1 color="text-main-default">Скрыть {count} предложений</ArticleParagraph1>
          <span className={styles['arrow']}>
            <IconActionChevronUpSmall16 color="icon-main-default" />
          </span>
        </>
      ) : (
        <>
          <ArticleParagraph1 color="text-main-default">Показать еще {count} предложений</ArticleParagraph1>
          <span className={styles['arrow']}>
            <IconActionChevronDownSmall16 color="icon-main-default" />
          </span>
        </>
      )}
    </div>
  );
};
